export default __webpack_public_path__ + "static/media/3dmodelOpacity.4e31b7b8.png";